import { render, staticRenderFns } from "./ReviewQualityControlDetail.vue?vue&type=template&id=efbc1582&scoped=true"
import script from "./ReviewQualityControlDetail.vue?vue&type=script&lang=js"
export * from "./ReviewQualityControlDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewQualityControlDetail.vue?vue&type=style&index=0&id=efbc1582&prod&scoped=true&lang=css"
import style1 from "./ReviewQualityControlDetail.vue?vue&type=style&index=1&id=efbc1582&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbc1582",
  null
  
)

export default component.exports